export default "__VITE_ASSET__CuVUG7VN__"